export default class newcolorEffectManager {
    constructor() {

    }

    text($target,type){

        if(type==="set"){
            var text = new SplitText($target, {type: "words,chars"}),
                chars = text.chars;
            TweenMax.set(chars, {y: '100%'});
        }else{
            TweenMax.staggerTo($target, 1.28, {
                y: '0%', ease: Power3.easeOut
            }, .03);
        }

    }

    planetext($target,type){

        if(type==="set"){
            TweenMax.set($target, {y: '50px', opacity: 0});
        }else{
            TweenMax.staggerTo($target, 1.28, {
                y: '0px',
                opacity: 1,
                ease: Power3.easeOut,
            },0.042);
        }

    }

    usetext($target,type,param){

        if(type==="set"){
            var text = new SplitText($target, {type: "words,chars"}),
                chars = text.chars;
            TweenMax.set(chars, {y: '100%'});
            TweenMax.set(".object01", {height: 0});
            TweenMax.set(".object02", {height: 0});
        }else{
            let _height = ((param.displayType === 'pc'))?78:35;
            TweenMax.to($target[0].querySelector(".object01"), .38, {
                height: _height, ease: Power1.easeOut
            });
            TweenMax.to($target[0].querySelector(".object02"), .38, {
                delay: .38, height: _height, ease: Power1.easeOut
            });
            TweenMax.staggerTo($target[0].querySelectorAll('.text>*>*'), 1.0,{
                y: '0%', ease: Power3.easeOut
            }, 0.03);
        }

    }

    colorNumber($target,type,param){

        if(type==="set"){
            TweenMax.set([".js__color-num .en", ".js__color-num .number"], {y: '100%'});
            TweenMax.set(".js__color-num .line", {width: '0px'});
        }else{
            let _width = ((param.displayType === 'pc'))?'120px':'70px';
            TweenMax.staggerTo([$target[0].querySelector('.en'), $target[0].querySelector('.number')], 0.88,{
                y: '0%', ease: Power3.easeOut
            },.58 );
            TweenMax.to($target[0].querySelector('.line'), 1.28, {
                width: _width, ease: Power3.easeOut
            });
        }

    }

    colorTitle($target,type){

        if(type==="set"){
            TweenMax.set(".js__color-title .bg", {opacity: 0, width: '0%'});
        }else{
            TweenMax.to($target[0].querySelector('.bg'), 1.18,
                {
                    opacity: 1, width: '99%', ease: Power3.easeOut
                }
            );
        }

    }

    photoFade($target,type){

        if(type==="set"){
            TweenMax.set(".js__photo-fade.top>*>*", {opacity: 0, y: '-30%'});
            TweenMax.set(".js__photo-fade.bottom>*>*", {opacity: 0, y: '30%'});
            TweenMax.set(".js__photo-fade.left>*>*", {opacity: 0, x: '-30%'});
            TweenMax.set(".js__photo-fade.right>*>*", {opacity: 0, x: '30%'});
        }else{
            for(var i=0; $target.length>i; i++) {
                TweenMax.to($target[i].querySelectorAll('.target'), 1.58,
                    {
                        opacity: 1, x: '0%', y: '0%', ease: Power2.easeOut
                    }
                );
            }
        }

    }


}
